import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Notifications.frontend.types'

@Injectable({ providedIn: 'root' })
export class Notifications_add_auto_email_rule_attachment_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { ruleId: string, properties: $frontendTypes.Notifications.i_auto_email_rule_attachment }): Promise<{ attachmentId?: string }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.ruleId)) {
      $missingRequiredInParams.push('\'ruleId\'');
    }
    if (isNil($inParams.properties)) {
      $missingRequiredInParams.push('\'properties\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

